export default function useLog() {

    

    // Add helper function for timestamp in format dd/MM hh:mm:ss
    const getTimeStamp = () => {
        const now = new Date();
        const pad = (n) => n.toString().padStart(2, '0');
        return `${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}.${pad(now.getMilliseconds())}`;
    };

    const formatProperties = (message, properties) => {
        if (!properties) return message;
        if (typeof properties === 'string') return `${message} ${properties}`;
        if (Array.isArray(properties)) return `${message} ${properties.join(' ')}`;
        if (typeof properties === 'object') return `${message} ${JSON.stringify(properties)}`;
        return message;
    };

    const LogInfo = (message, properties) => {
        console.log(`${getTimeStamp()} ${message}`);
    };

    const LogWarning = (message, properties) => {
        console.warn(`${getTimeStamp()} ${message}`);
    };

    const LogError = (message, properties) => {
        console.error(`${getTimeStamp()} ${message}`);
    };

    const LogVerbose = (message, properties) => {
        console.info(`${getTimeStamp()} ${message}`);
    };

    const LogMetric = (name, value) => {
        
    };

    return { LogInfo, LogWarning, LogError, LogVerbose, LogMetric };
}
